import Lightbox from 'vue-easy-lightbox';

export default Lightbox;
